"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelayedTooltip = exports.TOOLTIP_CLOSE_DELAY = exports.TOOLTIP_OPEN_DELAY = void 0;
exports.TOOLTIP_OPEN_DELAY = 500;
exports.TOOLTIP_CLOSE_DELAY = 200;
var react_1 = require("react");
var useDelayedTooltip = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, referenceElement = _a.referenceElement, popperElement = _a.popperElement, arrowElement = _a.arrowElement, isInteractive = _a.isInteractive, _b = _a.openDelay, openDelay = _b === void 0 ? exports.TOOLTIP_OPEN_DELAY : _b, _c = _a.closeDelay, closeDelay = _c === void 0 ? exports.TOOLTIP_CLOSE_DELAY : _c;
    var _d = (0, react_1.useState)(false), triggerDelayOpen = _d[0], setTriggerDelayOpen = _d[1];
    var _e = (0, react_1.useState)(false), triggerDelayClose = _e[0], setTriggerDelayClose = _e[1];
    var openTimer = (0, react_1.useRef)();
    var closeTimer = (0, react_1.useRef)();
    // Since we need to use setTimeout, which is considered a side effect,
    // we need to use useEffect. useEffect is a hook and so it cannot
    // be called from within another function. For example, we can't call
    // useEffect from inside onMouseOver. Instead, we introduce
    // a new state value, triggerDelayOpen, and use this as a flag within
    // useEffect.
    (0, react_1.useEffect)(function () {
        if (triggerDelayOpen && !openTimer.current) {
            openTimer.current = setTimeout(function () {
                setTriggerDelayOpen(false);
                if (!isOpen && (referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.matches(':hover'))) {
                    setIsOpen(true);
                }
                openTimer.current = undefined;
            }, openDelay);
        }
    }, [triggerDelayOpen, setIsOpen, isOpen, referenceElement, openDelay]);
    // Since we need to use setTimeout, which is considered a side effect,
    // we need to use useEffect. useEffect is a hook and so it cannot
    // be called from within another function. For example, we can't call
    // useEffect from inside onMouseLeave. Instead, we introduce
    // a new state value, triggerDelayClose, and use this as a flag within
    // useEffect.
    (0, react_1.useEffect)(function () {
        if (triggerDelayClose && !(closeTimer === null || closeTimer === void 0 ? void 0 : closeTimer.current)) {
            closeTimer.current = setTimeout(function () {
                setTriggerDelayClose(false);
                if (isOpen &&
                    !(referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.matches(':hover')) &&
                    (isInteractive ? !(popperElement === null || popperElement === void 0 ? void 0 : popperElement.matches(':hover')) && !(arrowElement === null || arrowElement === void 0 ? void 0 : arrowElement.matches(':hover')) : true)) {
                    setIsOpen(false);
                }
                closeTimer.current = undefined;
            }, closeDelay);
        }
    }, [triggerDelayClose, setIsOpen, isOpen, referenceElement, isInteractive, popperElement, arrowElement, closeDelay]);
    return {
        startDelayedOpen: function () { return setTriggerDelayOpen(true); },
        startDelayedClose: function () { return setTriggerDelayClose(true); },
    };
};
exports.useDelayedTooltip = useDelayedTooltip;
